import TargetOrder from './targetOrder';
import { sortBy } from 'utilities/sorting';
import moment from 'moment-timezone';
import { TIME_ZONE } from '@silvergatedelivery/constants';

// Adapter for Silvergate
export default class SilvergateAdapter extends TargetOrder {
  constructor(sourceData) {
    const errors = [];
    if (sourceData.length === 0) {
      errors.push('上傳的檔案無資料');
    }
    if (sourceData.some((data) => !data['訂單編號'])) {
      errors.push('有訂單資料缺少訂單編號，缺少訂單編號的訂單將不會被匯入');
    }

    const sortedSourceData = sourceData.filter((data) => data['訂單編號']).sort(sortBy('訂單編號'));

    const orders = sortedSourceData.map((data) => {
      const orderName = data['訂單編號'];
      let deliveryDatetime;
      if (data['送餐時間'] && moment(data['送餐時間'], moment.ISO_8601, true).isValid()) {
        deliveryDatetime = moment(data['送餐時間']).tz(TIME_ZONE).toISOString();
      }
      const elderIdentificationCardId = data['送餐對象身分證字號'];
      const mealName = data['餐點名稱'];
      const mealQuantity = parseInt(data['餐點數量'], 10);
      const deliveryStaffFee = parseInt(data['送餐費用'], 10);
      const noteForMeal = data['餐點備註'];
      const noteForDelivery = data['送餐備註'];
      const deliveryStaffName = data['送餐大使姓名'];
      const restaurantName = data['餐廳'];
      return {
        deliveryDatetimes: deliveryDatetime ? [deliveryDatetime] : [],
        noteForDelivery,
        noteForMeal,
        category: '送餐',
        mealItems: [{
          name: mealName,
          quantity: mealQuantity && !isNaN(mealQuantity) ? mealQuantity : undefined,
        }],
        referenceId: orderName,
        source: 'web',
        deliveryStaffName,
        elder: elderIdentificationCardId ? {
          identificationCardId: elderIdentificationCardId,
        } : undefined,
        deliveryStaffFee: deliveryStaffFee && !isNaN(deliveryStaffFee) ? deliveryStaffFee : undefined,
        restaurantName,
      };
    });

    super(orders, errors, false, false);
  }
}
